import React from "react";
import {
    BlockType,
    ContentType,
    FieldType,
    IFaqProp,
    IFrameProps,
    LinkItemType,
    ModelType,
    PageImageType,
    PageListType,
    ProductCategoryType,
    ProductType,
    ReviewType
} from "../../../../types";
import parse from "html-react-parser";

// Pages
import PageImage from "../../../content/PageImage";
import PageList from "../../../content/PageList";
import LinkItem from "../../../content/LinkItem";
import CustomBreadcrumb from "../../../shared/CustomBreadcrumb";
import Slider from "../../../shared/Slider";
import ReviewList from "../../../ecommerce/ReviewsList";
import Faq from "../../../content/Faq";

// Headless CMS
import CMSContentList from "../../../content/CMSContentList";
import CMSContentItem from "../../../content/CMSContentItem";

// Ecommerce
import ProductList from "../../../ecommerce/ProductList";
import ProductDetail from "../../../ecommerce/ProductDetail";
import ProductSelector from "../../../ecommerce/ProductSelector";
import { ISalesChannel } from "../../../../services/ecommerceApi/SalesChannel/types";
import GetComponent from "../../../websiteTemplates/_GetComponent";
import EditorJsRenderer from "../../../shared/EditorJSRender";
import IFrame from "../../../content/IFrame";
import BackgroundImage from "../../../content/BackgroundImage";
import EmailRedirect from "../../../content/EmailRedirect";
import KlaviyoTriggerForm, { IKlaviyoTriggerForm } from "../../../content/Klaviyo/TriggerForm";
import VideoField, { VideoFieldProps } from "../../../content/Video";
import ProductBuyButton from "../../../ecommerce/ProductBuyButton";
import SingleProductDetail from "../../../ecommerce/SingleProductDetail";

interface Props {
    field: FieldType;
    location: any;
    pageTitle: string;
    salesChannel: ISalesChannel;
    block?: BlockType;
}

export default function Field({ field, location, pageTitle, salesChannel, block }: Props) {
    const data = field.data;
    const val = JSON.parse(field?.value || "{}")?.value;
    const valType = typeof val;

    try {
        switch (field.fieldId) {
            case "product":
                const defaultProduct = (data.product || val) as ProductType;
                return <ProductSelector {...defaultProduct} />;
            case "product-detail": // THIS SHOULD BE PRODUCT CATEGORY DETAIL
                return <ProductDetail {...data} />;
            case "single-product-detail":
                const single = (data.product || val) as ProductType;
                return <SingleProductDetail {...single} />;
            case "product-buy-button":
                const product = data?.product as ProductType;
                return <ProductBuyButton {...product} />;
            case "products":
                const productCategory = data?.productCategory as ProductCategoryType;
                return <ProductList productCategory={productCategory} />;
            case "product-category-list":
                var categories = (data.categories || []) as ProductCategoryType[];
                var displayType = data.displayType || "list";
                return (
                    <GetComponent
                        template={salesChannel.websiteTemplate}
                        component="ProductCategoryList"
                        props={{ categories, salesChannel: salesChannel, displayType }}
                    />
                );
            case "page-list":
                var pageListConfig = val as PageListType;
                return <PageList pageListConfig={pageListConfig} field={field} />;
            case "link":
                var linkItem = val as LinkItemType;
                return <LinkItem linkItem={linkItem} />;
            case "email-redirect":
                var linkItem = val as LinkItemType;
                return <EmailRedirect linkItem={linkItem} />;
            case "klaviyo-form-trigger":
                var kldata = val as IKlaviyoTriggerForm;
                return <KlaviyoTriggerForm data={kldata} />;
            case "image":
                var pageImage = val as PageImageType;
                return <PageImage pageImage={field} />;
            case "file_url":
                var pageImage = val as PageImageType;
                var url = pageImage.src;
                return typeof url === "string" ? url : null;
            case "reviews":
                return <ReviewList reviews={val?.reviews as ReviewType[]} count={val?.noOfReviews} />;
            case "cms_item":
                return undefined;
            // return (
            //     <CMSContentItem
            //         id={val.contentId}
            //         selectedTransformation={val.selectedTransformation}
            //     />
            // );
            case "cms_list":
                return (
                    <CMSContentList
                        modelID={val.modelID}
                        transformation={val.selectedTransformation}
                    />
                );
            case "slider":
                return <Slider field={field} />;
            case "faq":
                return <Faq data={val as IFaqProp} />;
            case "iframe":
                return <IFrame data={val as any} />;
            case "breadcrumb":
                return (
                    <CustomBreadcrumb
                        crumbs={[
                            {
                                pathname: location.pathname,
                                crumbLabel: pageTitle,
                                crumbSeparator: " > "
                            }
                        ]}
                    />
                );
            case "html":
                let storedhtml = JSON.stringify(val);
                return <EditorJsRenderer content={storedhtml} />;
            case "wysiwyg":
                return parse(val);
            case "background_image":
                return (
                    <BackgroundImage
                        field={field}
                        block={block as BlockType}
                        salesChannel={salesChannel}
                        pageTitle={pageTitle}
                    />
                );
            case "form":
                return <GetComponent template={salesChannel.websiteTemplate} component="Form" props={{ val }} />;
            case "video":
                var videoFieldProps = val as VideoFieldProps;
                return <VideoField videoFieldProps={videoFieldProps} field={field} />;
            default:

                if (valType === "string" || valType === "number") {
                    return <div className="editor-renderer" dangerouslySetInnerHTML={{ __html: val }}></div>;
                }

                return JSON.stringify(val);
        }
    } catch (e) {
        console.warn("e", e, field);
        return null;
    }
}
